import { Button, ButtonType, Form, SubmitButton, Switch, Checkbox } from '@digicert/dcone-common-ui'
import React, { useEffect, useState } from 'react'
import { ExtendedTwoFactorAuthProps, IVerificationType } from './TwoFactorAuth.types'
import { Translate } from 'react-localize-redux'
import styles from './TwoFactorAuth.module.scss'
import { enableMfa } from 'secure-pages/tenants/Tenants.actions'
import { connect } from 'react-redux'
import { translate } from 'shared/helpers/utils'
import { IAccessScope } from 'reducers/Reducers.interfaces'

const TwoFactorAuthentication = ({ onCancel, account, enableMfa, updateDetails, accessScope }: ExtendedTwoFactorAuthProps) => {
  const [enable2FA, setEnable2FA] = useState(account.mfa_enabled)
  const [verificationTypes, setVerificationTypes] = useState<IVerificationType[]>(account.mfa_types)
  const [cacDisabled, setCacDisabled] = useState(account?.sign_in_methods.find(item => item.signInMethod === 'standard')?.clientAuthCert1faEnabled === true)

  const resetData = () => {
    setEnable2FA(account.mfa_enabled)
    setVerificationTypes(account.mfa_types)
  }

  const handleVerificationTypeChange = (event, verificationType: IVerificationType,) => {
    setVerificationTypes(prevTypes => {
      if (event.checked) {
        return prevTypes.includes(verificationType)
          ? prevTypes
          : [...prevTypes, verificationType]
      } else {
        return prevTypes.filter(type => type !== verificationType)
      }
    })
  }

  useEffect(() => {
    setCacDisabled(account?.sign_in_methods.find(item => item.signInMethod === 'standard')?.clientAuthCert1faEnabled === true)
  }, [account])

  useEffect(() => {
    resetData()
  }, [onCancel])

  const handleCancel = (e) => {
    e.preventDefault()
    if (onCancel) {
      //@ts-ignore TODO : Expected 0 arguments, but got 1
      onCancel(e)
    }
  }

  const updateTwoFactorAuth = (e) => {
    e.preventDefault()
    const payload = { enabled: enable2FA, mfa_types: verificationTypes }
    enableMfa(account.id, payload, <Translate id='notifications.mfa.updated' data={{ name: <b>{account.name}</b> }} />).then(() => {
      updateDetails()
      handleCancel(e)
    })
  }

  return (
    <Form onSubmit={updateTwoFactorAuth} className={styles.twoFactorAuth}>
      <div className={styles.toggle2FA}>
        <h6 className={styles.heading}><Translate id='singleSignOn.toggle2FA' /></h6>
        <Switch
          offLabel={translate('common.form.buttons.off') as string}
          onChange={() => { setEnable2FA(prevState => !prevState) }}
          onLabel={translate('common.form.buttons.on') as string}
          size='default'
          checked={enable2FA}
          disabled={accessScope !== IAccessScope.system && account.mfa_enabled}
        />
      </div>
      {enable2FA && <div className={styles.verificationMethod}>
        <h6 className={styles.heading}><Translate id='singleSignOn.verificationMethods' /></h6>
        <Checkbox
          help={translate('singleSignOn.mfaOption1Desc') as string}
          label={translate('singleSignOn.mfaOption1') as string}
          onChange={(checked) => handleVerificationTypeChange(checked, IVerificationType.AUTHENTICATOR_APP)}
          size='default'
          value={IVerificationType.AUTHENTICATOR_APP}
          checked={verificationTypes.includes(IVerificationType.AUTHENTICATOR_APP)}
        />
        <Checkbox
          help={translate('singleSignOn.mfaOption2Desc') as string}
          label={translate('singleSignOn.mfaOption2') as string}
          onChange={(checked) => handleVerificationTypeChange(checked, IVerificationType.EMAIL,)}
          size='default'
          value={IVerificationType.EMAIL}
          checked={verificationTypes.includes(IVerificationType.EMAIL)}
        />
        <Checkbox
          help={translate('singleSignOn.mfaOption3Desc') as string}
          label={translate('singleSignOn.mfaOption3') as string}
          onChange={(checked) => handleVerificationTypeChange(checked, IVerificationType.CAC)}
          size='default'
          value={IVerificationType.CAC}
          checked={verificationTypes.includes(IVerificationType.CAC)}
          disabled={cacDisabled}
        />
      </div>}
      <div className={styles.formActions}>
        <Button buttonType={ButtonType.SECONDARY} onClick={handleCancel}>
          <Translate id='common.form.buttons.cancelBtn' />
        </Button>
        <SubmitButton disabled={verificationTypes.length === 0} buttonType={ButtonType.PRIMARY}>
          <Translate id='common.form.buttons.update2fa' />
        </SubmitButton>
      </div>
    </Form>
  )
}

export default connect(null, { enableMfa })(TwoFactorAuthentication)